import { render, staticRenderFns } from "./StandaloneScreenshotPreview.vue?vue&type=template&id=10d8ca8f&"
import script from "./StandaloneScreenshotPreview.vue?vue&type=script&lang=ts&"
export * from "./StandaloneScreenshotPreview.vue?vue&type=script&lang=ts&"
import style0 from "./StandaloneScreenshotPreview.vue?vue&type=style&index=0&id=10d8ca8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports